import React, { useState, useEffect } from 'react';
import './WorklogReport.css';
import Navbar from '../../Navbar/Navbar';
import DatePicker from 'react-datepicker';
import { useDispatch, useSelector } from "react-redux";
import { startOfMonth, endOfMonth } from "date-fns";
import { empList } from '../../../Redux/DailyUpdateApproval/Action';
import Select from "react-select";
import { fetchWorkLogData, getWorklogData } from '../../../Redux/Task/Action';
import NewDataTable from '../../DataTable/NewDataTable';
import Icon from "../../utility/Icon";
import { IoTimeOutline } from "react-icons/io5";


const WorklogReport = () => {
    const dispatch = useDispatch();
    const token = localStorage.getItem("token");
    const loginId = localStorage.getItem("loginId");
    const role = localStorage.getItem("role");
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const { emplists } = useSelector((store) => store.dailyUpdateApprover);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [taskId, setTaskId] = useState("");
    const [taskNumber, setTaskNumber] = useState("");
    const [taskTitle, setTaskTitle] = useState("");
    const [showWorklogModal, setshowWorklogModal] = useState(false);

    const { fetchWorklogData, taskWorklogdata } = useSelector((store) => store.task);


    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${year}-${month}-${day}`;
    };

    const handleEmpChange = (selectedOption) => {
        setSelectedEmployee(selectedOption);
    };

    useEffect(() => {
        dispatch(empList(token));
    }, [])

    let options = [
        { value: 'All', label: 'All' },
        ...emplists.map((emp) => ({
            value: emp.loginId,
            label: `${emp?.firstName || ""} ${emp?.lastName || ""}`,
        })),
    ];

    if (role === "ROLE_EMP" || role === "ROLE_SUPPORT") {
        options = options.filter((opt) => opt.value === loginId);
    }

    useEffect(() => {
        if (options.length > 0 && selectedEmployee === null) {
            setSelectedEmployee(options[0]);
        }
    }, [options, selectedEmployee]);


    useEffect(() => {
        if (selectedEmployee && fromDate && toDate) {
            dispatch(fetchWorkLogData(selectedEmployee.value, token, formatDate(fromDate), formatDate(toDate)));
        }
    }, [dispatch, selectedEmployee, fromDate, toDate,])

    const Tooltip = ({ text, children }) => {
        return (
            <div className="tooltip-container">
                {children}
                <div className="tooltip">{text}</div>
            </div>
        );
    };

    const handelfetchWorklog = (e) => {
        const id = role === "ROLE_ADMIN" ? "All" : loginId;
        dispatch(getWorklogData(e.taskMasterId, token, id));
        setTaskId(e.taskMasterId);
        setshowWorklogModal(true);
        setTaskNumber(e.taskNo);
        setTaskTitle(e.taskTitle);
    };


    const columns = [
        {
            name: "SN",
            cell: (_, index) => index + 1,
            sortable: false,
            width: "80px",
            align: "center",
        },


        ...(role === "ROLE_ADMIN"
            ? [
                {
                    name: "Employee Name",
                    selector: (row) => row.empName?.trim() || "-",
                    sortable: true,
                    align: "center",
                },
            ]
            : []),
        {
            name: "Task No",
            selector: (row) => row.taskNo || "-",
            sortable: true,
            align: "center",
        },

        {
            name: "Project Code",
            selector: (row) => row.projectCode || "-",
            sortable: true,
            align: "center",
        },
        {
            name: "Task Title",
            selector: (row) => row.taskTitle || "-",
            sortable: true,
            align: "left",
        },
        {
            name: "Date",
            selector: (row) => row.date || "-",
            sortable: true,
            align: "center",
        },
        {
            name: "Hours",
            selector: (row) => row.totalHour || "-",
            sortable: true,
            align: "center",
        },
        {
            name: "Remark",
            selector: (row) => row.remarks || "-",
            sortable: true,
            align: "left",
        },

        {
            name: "Action",
            selector: (row) => row,
            sortable: false,
            align: "center",
            cell: (row) => (
                <div>

                    <Tooltip text="View Worklog">
                        <Icon
                            icon={IoTimeOutline}
                            variant="primary"
                            className="me-3"
                            onClick={() => handelfetchWorklog(row)}
                        />
                    </Tooltip>
                </div>
            ),
        },

    ];



    return (
        <div>
            <Navbar></Navbar>

            <div className="main-content">
                <div className="container-fluid mt-4">
                    <div className="row mb-3 justify-content-end align-items-center flex-wrap">

                        {/* Employee Select */}
                        <div className="col-auto d-flex align-items-center flex-nowrap mb-2 mb-sm-0">
                            <b>
                                <label className="me-1 mb-0 custom-label">Employee:</label>
                            </b>
                            <div style={{ width: "300px" }}>
                                <Select
                                    options={options}
                                    value={selectedEmployee}
                                    onChange={handleEmpChange}
                                    placeholder="Select Employee"
                                    isClearable
                                />
                            </div>
                        </div>

                        {/* From & To Dates in one row */}
                        <div className="col-auto d-flex align-items-center flex-nowrap mb-2 mb-sm-0">
                            <b>
                                <label className="me-1 mb-0 custom-label cstm-label">From Date:</label>
                            </b>
                            <DatePicker
                                selected={fromDate}
                                onChange={(newValue) => setFromDate(newValue)}
                                className="form-control me-3"
                                dateFormat="dd-MM-yyyy"
                                showYearDropdown
                                showMonthDropdown
                                dropdownMode="select"
                                onKeyDown={(event) => event.preventDefault()}
                            />

                            <b>
                                <label className="me-1 ms-2 mb-0 custom-label cstm-label">To Date:</label>
                            </b>
                            <DatePicker
                                selected={toDate}
                                onChange={(newValue) => setToDate(newValue)}
                                className="form-control"
                                dateFormat="dd-MM-yyyy"
                                showYearDropdown
                                showMonthDropdown
                                dropdownMode="select"
                                onKeyDown={(event) => event.preventDefault()}
                                minDate={fromDate}
                            />
                        </div>

                    </div>

                    <div>
                        <NewDataTable
                            columns={columns}
                            data={fetchWorklogData.taskWorkLogList || []}
                            tableName="WORKLOG LIST"
                        />
                    </div>
                    {showWorklogModal && <div className="modal-backdrop fade show"></div>}
                    <div
                        className={`modal fade worklog-modal ${showWorklogModal ? "show d-block" : ""}`}
                        tabIndex="-1"
                        role="dialog"
                    >
                        <div className="modal-dialog modal-xl" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Work Logs for Task No : {taskNumber || ""} - {taskTitle || ""}</h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => setshowWorklogModal(false)}
                                        aria-label="Close"
                                    ></button>
                                </div>
                                <div className="modal-body">
                                    <div className="row">
                                        <table className="table mt-2">
                                            <thead>
                                                <tr>
                                                    <th>SN</th>
                                                    {role === "ROLE_ADMIN" && <th>Employee</th>}
                                                    <th>Date</th>
                                                    <th>Total Hour</th>
                                                    <th>Remarks</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Array.isArray(taskWorklogdata) && taskWorklogdata.length > 0 ? (
                                                    taskWorklogdata.map((workLog, index) => (
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            {role === "ROLE_ADMIN" && <td>{workLog?.empName || "-"}</td>}
                                                            <td>{workLog?.date || "-"}</td>
                                                            <td>{workLog?.totalHour ?? "-"}</td>
                                                            <td className="text-start">{workLog?.remarks || "-"}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="4" className="text-center">
                                                            No logs available
                                                        </td>
                                                    </tr>
                                                )}

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default WorklogReport;